import { Flex, type FlexProps } from 'antd';
import {
  type ComponentProps,
  type FC,
  type PropsWithChildren,
  type ReactNode,
  isValidElement,
} from 'react';
import { Box } from '../Box';
import { Text } from '../Text';
import { INDEX_TEXT_WIDTH } from './Table';
import { PDF_BORDER, SECTION_TITLE_BACKGROUND_COLOR } from './constants';

type Props = {
  title?: ReactNode | string | number;
  indexText?: string;
  titleWrapperStyle?: FlexProps['style'];
  titleContentStyle?: FlexProps['style'];
  wrapperStyle?: FlexProps['style'];
  innerStyle?: FlexProps['style'];
  contentWrapperStyle?: FlexProps['style'];
  titleTextProps?: Omit<ComponentProps<typeof Text>, 'text'>;
  isLastIndex: boolean;
};

export const ReportSectionItem: FC<PropsWithChildren<Props>> = ({
  title,
  titleWrapperStyle,
  titleContentStyle,
  wrapperStyle,
  innerStyle,
  titleTextProps,
  children,
  indexText,
  isLastIndex,
}) => {
  return (
    <Flex
      style={{
        border: PDF_BORDER.THIN,
        borderBottom: isLastIndex ? PDF_BORDER.THIN : 'none',
        boxSizing: 'border-box',
        height: '100%',
        ...wrapperStyle,
      }}
    >
      <Flex>
        {indexText && (
          <Flex
            style={{
              alignItems: 'center',
              width: INDEX_TEXT_WIDTH,
              borderRight: PDF_BORDER.THIN,
              backgroundColor: SECTION_TITLE_BACKGROUND_COLOR,
              boxSizing: 'border-box',
            }}
          >
            {isValidElement(indexText) ? (
              <>{indexText}</>
            ) : (
              <Flex
                align="center"
                justify="center"
                style={{
                  padding: '2px 8px',
                  boxSizing: 'border-box',
                }}
              >
                <Text
                  variant="footnote"
                  weight="bold"
                  style={{ ...titleTextProps?.style }}
                  text={indexText as string | number}
                />
              </Flex>
            )}
          </Flex>
        )}
        {title && (
          <Flex
            style={{
              alignItems: 'center',
              width: 140,
              borderRight: PDF_BORDER.THIN,
              backgroundColor: SECTION_TITLE_BACKGROUND_COLOR,
              boxSizing: 'border-box',
              ...titleWrapperStyle,
            }}
          >
            {isValidElement(title) ? (
              <>{title}</>
            ) : (
              <Flex
                align="center"
                style={{
                  padding: '2px 8px',
                  boxSizing: 'border-box',
                  ...titleContentStyle,
                }}
              >
                <Text
                  variant="footnote"
                  {...titleTextProps}
                  style={{ ...titleTextProps?.style }}
                  weight="bold"
                  text={title as string | number}
                />
              </Flex>
            )}
          </Flex>
        )}
      </Flex>
      <Box width="100%" {...innerStyle}>
        {children}
      </Box>
    </Flex>
  );
};
